export const isBusinessUser = (user) => {
  if (!user) return false;
  const { subscriptionLevel } = user;
  // 11 is the suggested for the short term business (nigh unlimited credits) fix
  return subscriptionLevel > 10;
};
